import { createSelector } from "reselect"

import { getNotificationState } from "./getNotificationState"

export const getSuccesses = createSelector(
  getNotificationState,
  (state) => state.successes
)
